import { toastSeconds } from "../features/general/generalSlice";

export const toastMessage = (message: string, dispatch: any, toast: any) => {
  //   console.log(message.length);

  if (message.length >= 100) {
    toast(message);
    dispatch(toastSeconds(12000));
  } else if (message.length >= 50 && message.length < 100) {
    toast(message);
    dispatch(toastSeconds(8000));
  } else {
    toast(message);
    dispatch(toastSeconds(5000));
  }
};
